/* eslint-disable */
import { ICalendarSelectorItem } from "../types";
import { convertCalendarItem } from "./convertCalendarItem";
import { last } from "lodash";

function getNumberIdByItemIndex(items: ICalendarSelectorItem[], index: number): [number, ICalendarSelectorItem] {
  const item = items[index];
  return [Number(item.item.id), item];
}

type StepIteratorType = (iterator: [number, ICalendarSelectorItem, ICalendarSelectorItem]) => void;
function forItems(items: ICalendarSelectorItem[], iterator: StepIteratorType) {
  for (let i = 0; i < items.length - 1; i++) {
    const [item1Id, item1] = getNumberIdByItemIndex(items, i);
    const [item2Id, item2] = getNumberIdByItemIndex(items, i + 1);
    const step = item2Id - item1Id;
    iterator([step, item1, item2]);
  }
}

export function fillCalendar(items: ICalendarSelectorItem[], groupSize: number, fillBlank: (fillId: string) => string) {
  let minStep = Number.MAX_VALUE;

  // find minStep
  forItems(items, ([step]) => {
    if (minStep > step) {
      minStep = step;
    }
  });

  const result: ICalendarSelectorItem[] = [];
  forItems(items, ([step, item1, item2]) => {
    if (items.indexOf(item1) === 0) {
      result.push(item1);
    }
    if (minStep < step) {
      let currentStep = step;
      let nextNumberId = Number(item1.item.id);
      while (currentStep > minStep) {
        currentStep -= minStep;
        nextNumberId += minStep;
        const id = `${nextNumberId}`;
        const nextItem: ICalendarSelectorItem = convertCalendarItem(
          {
            id,
            disabled: true,
            name: fillBlank(id),
            frequency: item1.item.frequency,
            parent: item1.item.parent,
          },
          false,
          true,
        );
        result.push(nextItem);
      }
    }
    result.push(item2);
  });

  if (result.length % groupSize !== 0) {
    result.reverse();

    while (result.length % groupSize !== 0) {
      const item = last(result)!;
      const nextNumberId = Number(item.item.id) - minStep;
      const id = `${nextNumberId}`;
      const nextItem: ICalendarSelectorItem = convertCalendarItem(
        {
          id,
          disabled: true,
          name: fillBlank(id),
          frequency: item.item.frequency,
          parent: item.item.parent,
        },
        false,
        true,
      );
      result.push(nextItem);
    }

    result.reverse();
  }

  return result;
}
